<script setup lang="ts">
import Operation from "@/views/playground/planner/business-management/service-management/Operation.vue";
</script>

<template>
  <operation></operation>
</template>

<style scoped></style>
